module.exports = __webpack_public_path__ + "img/canyon_light_grey_ba_list.4ae3c34b.jpg";